module.exports = __webpack_public_path__ + "img/sk.cd170fef.svg";